import { Box } from '@mui/material'
import React from 'react'
import { sendParameters } from '../../../common/functions'
import FileUpload from '../../../components/file/FileUpload'
import FileViewWidget from '../../../components/file/FileView'
import TaskWrapper from './TaskWrapper'

export default function UniversalTransferDocumentWidget({ task, isCanceled }) {
  const [files, setFiles] = React.useState(task.files || [])

  const enabled = task.isActive && task.accessFlags.update && !isCanceled

  return (
    <TaskWrapper
      task={task}
      isCanceled={isCanceled}
      label="УПД"
      onSave={() => sendParameters(task.paidServiceId, task.id, {}, files)}
    >
      <Box display="flex" flexDirection="column" gap={3}>
        {enabled ? (
          <FileUpload
            files={files}
            onUpload={(file) => setFiles([...files, file])}
            onDelete={(id) => setFiles(files.filter((file) => file.id === id))}
          />
        ) : (
          <FileViewWidget files={task.files} />
        )}
      </Box>
    </TaskWrapper>
  )
}
